import script from "./item5.vue?vue&type=script&setup=true&lang=js"
export * from "./item5.vue?vue&type=script&setup=true&lang=js"

import "./item5.vue?vue&type=style&index=0&id=1c89c310&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c89c310"]])

export default __exports__